export default function loginReducer(state: any = {}, action: any) {
    switch (action.type) {
        default:
            return state;
    }
}